export const itemsPerLoad = 5;
export const desktopVideosLimit = 20;
